export default __webpack_public_path__ + "static/media/parent-banner.88e43b97.jpg";